<template>
  <div>
    <div  @click="chiudi()" v-if="infoDispositivoIndex!=null" class="form d-flex align-items-center justify-content-center">
      <transition  v-on:after-enter="daiFocus()" name="custom" v-on:after-leave="esci()" enter-active-class="swal2-show" leave-active-class="swal2-hide">
        <div @click.stop="" v-if="mostraInserimento" class="evidenzia container" style="background-color:white;">
          <div class="row intestazione">
            <div class="col-12 text-center my-auto">iPhone 6</div>
          </div>
          <div class="container">
            <div class="row">
              <div class="col-4 d-flex align-items-center justify-content-center">
                <img
                  src="https://firebasestorage.googleapis.com/v0/b/jestionale-bfde2.appspot.com/o/Altro_mondo%2Fmodelli%2F-LaCerCK4ArZsDzAwiw3?alt=media"
                >
              </div>
              <div class="col-8 d-flex blocco align-items-center justify-content-center">
                <div>
                  <label style="float:left;">Codice Sblocco</label>
                  <input v-model="sblocco"  autocomplete="disabled" id="cod_sblocco">
                  <label style="float:left;">Da consegnare entro</label>

                  <div class="consegna row">
                    <div class="select">
                      <select class="select__field">
                        <option>Oggi</option>
                      </select>
                    </div>
                    <div class="select">
                    <select class="select__field">
                      <option>alle 18.00</option>
                    </select>
                    </div>
                  </div>

                  <label style="float:left;">Note</label>
                  <input v-model="note" placeholder>
                </div>
              </div>
            </div>
          </div>
          <div class="row add">
            <div class="col-8 d-flex align-items-center text-center my-auto">
              <input type="checkbox">
              <span class="mostra">Mostra automaticamente questo box</span>
            </div>

            <div class="col-4 d-flex align-items-center justify-content-center">
              <div @click="saveDeviceDettails()" class="tasto">Salva</div>
            </div>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import { EventBus } from "../main.js";
import { db } from "@/components/Firebase_Conn";
import { ref } from "@/components/puntatori";
import { jStore } from "../store/jestionaleStore.js";
import { mapState, mapGetters } from "vuex";
import Vue from "vue";

export default {
  name: "infoDispositivo",
  directives: {},
  data() {
    return {
      mostraInserimento: false,
      sblocco: '',
      note: ''
      //VARIABILI AMBIENTE
    };
  },
  props: ["device"],
  computed: {   ...mapGetters({
      infoDispositivoIndex: "ordineStates/infoDispositivoIndex",
      cart: "ordineStates/cart",
      deviceList: "ordineStates/deviceList",
      deviceDettails: "ordineStates/deviceDettails"
     
    }),},
  methods: {
     daiFocus(){
      cod_sblocco.focus();
    },
    chiudi(){
      this.mostraInserimento = false
    },
    esci(){
      this.$store.commit("ordineStates/mostraInfo", null);    
    },
    saveDeviceDettails() {
      var payload = {
        sblocco: this.sblocco,
        note: this.note
      };
      this.$store.commit("ordineStates/setDeviceDettails", payload);
      this.chiudi();
    }
  },
 mounted() {
   let self = this
   Vue.nextTick(function () {
   self.mostraInserimento = true
   self.sblocco = (self.deviceDettails && self.deviceDettails.sblocco) || ''
   self.note = (self.deviceDettails && self.deviceDettails.note) || ''
})
  },
  watch: {
  }
};
</script>

<style scoped>
.blocco {
  padding-top: 4vh;
  padding-bottom: 4vh;
}
.consegna {
  padding-top: 2vh;
  padding-left: 2vw;
  width: 100%;
  height: 6vh;
  margin-bottom: 2vh;
}

.mostra {
  margin-left: 1vw;
  font-weight: 10;
  font-size: 1.5vh;
  color: darkgray;
}

.info {
  margin-left: 10px;
  padding: 0.5vh;
  font-size: 10px;
  font-weight: 10;
  color: #7f8c8d;
}

.tasto {
  padding-left: 4.2vh;
  padding-right: 4.2vh;
  padding-top: 0.5vh;
  padding-bottom: 0.5vh;
  background-color: #27ae60;
  color: white;
  cursor: pointer;
  -webkit-border-radius: 8px;
  -moz-border-radius: 8px;
  border-radius: 8px;
  position: relative;
}

.add {
  height: 7vh;
  background-color: white;
  font-weight: bold;
  font-size: 1.7vh;
  -webkit-border-bottom-right-radius: 9px;
  -webkit-border-bottom-left-radius: 9px;
  -moz-border-radius-bottomright: 9px;
  -moz-border-radius-bottomleft: 9px;
  border-bottom-right-radius: 9px;
  border-bottom-left-radius: 9px;
}

.form {
  background-color: rgba(0, 0, 0, 0.5);
  position: fixed;
  top: 0px;
  left: 0px;
  z-index: 9999;
  height: 100%;
  width: 100%;
}

.scadenza {
}
.scadenza:focus {
  outline: none;
}

.form > div {
  width: 34vw;
  background-color: white;
  -webkit-border-radius: 10px;
  -moz-border-radius: 10px;
  border-radius: 10px;
}

.form input:not([type="checkbox"]) {
  padding-left: 1vw;
  height: 5vh;
  width: 100%;
  border: none;
  border-bottom: solid 2px #f3f3f3;
  transition: all 0.2s;
  margin-bottom: 1vh;
  text-align: left;
  padding-right: 7px;
}
.form input:not([type="checkbox"]):focus {
  outline: none;
  border-bottom: solid 2px #007bff;
}

.form label {
  font-size: 1.7vh;
  color: #848484;
  margin-top: 1vh;
  margin-left: 1vh;
  margin-bottom: 0vh;
}

.intestazione {
  height: 6vh;
  background-color: #595959;
  color: white;
  font-weight: bold;
  font-size: 2vh;

  -webkit-border-radius: 9px;
  -webkit-border-bottom-right-radius: 3px;
  -webkit-border-bottom-left-radius: 3px;
  -moz-border-radius: 9px;
  -moz-border-radius-bottomright: 3px;
  -moz-border-radius-bottomleft: 3px;
  border-radius: 9px;
  border-bottom-right-radius: 3px;
  border-bottom-left-radius: 3px;
}

.select {
  overflow: hidden;
  position: relative;
  border-radius: 3px;
  margin-bottom: 1em;
}

.select:after {
  content: "▼";
  display: flex;
  align-items: center;

  position: absolute;
  right: 1.5vw;
  top: 0;
  z-index: 1;
  text-align: center;
  height: 100%;
  pointer-events: none;
  font-size: 1.6vh;
  color: #5e5e5e;
}

.select__field {
  margin-right: 1vw;
  border: 0;
  background-color: #e6e6e6;
  padding-left: 1.5vw;
  padding-right: 2.2vw;
  -webkit-appearance: none; /* remove the strong OSX influence from Webkit */
  height: 5vh;

  color: #616263;

  outline: none;
  border: none;

  -webkit-appearance: none;
  /* for webkit browsers */
  -moz-appearance: none;
  /* for firefox */
  appearance: none;
  /* for modern browsers */
}

/* remove default caret for ie */

.select__field::-ms-expand {
  display: none;
}
</style>
